import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { TopicFilterNames } from 'components/TopicFilters/shared';
import { sortOrderTypes } from 'types/shared';
import { EntityTypes, SalesTypes } from 'context/entityContext';
import getCountryIds from 'helpers/getCountryIds';

interface ITerritoryKPIURLArgs {
  countryIds?: string[] | string;
  customerFilter?: TopicFilterNames[];
  download?: boolean;
  entityType: EntityTypes;
  entityIds: string[];
  limit?: number;
  offset?: number;
  salesType?: SalesTypes;
  sortMetric?: string;
  sortOrder?: sortOrderTypes;
  mediaTypes?: string;
  region?: string;
  customRegion?: string | string[];
}

export default function getTerritoryKPIURL(args: ITerritoryKPIURLArgs): string {
  const {
    countryIds,
    customerFilter,
    download,
    entityType,
    entityIds,
    limit,
    offset,
    salesType,
    sortMetric,
    sortOrder,
    mediaTypes,
    region,
    customRegion,
  } = args;

  const type = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    salesType,
    customerFilter,
    sortMetric,
    sortOrder,
    offset,
    limit,
    download,
    mediaTypes,
  });

  return `/api/territory/kpi/${type}/${entityIds}?${params}`;
}
